import { mapCompanyType, useFindCompanySuspense, useUpdateCompany } from '@api';
import { useNotification } from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { AxiosError } from 'axios';
import { Route } from 'src/routes/_rootLayout/companies/$id';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_COMPANY';

type UseClosePartnerToggleReturnType = {
  isPartner: boolean;
  isPending: boolean;
  toggleClosePartner: () => Promise<void>;
  canEdit: boolean;
};

export const useClosePartnerToggle = (): UseClosePartnerToggleReturnType => {
  const { id } = Route.useParams();
  const { data: company } = useFindCompanySuspense(id, {
    query: { select: (response) => mapCompanyType(response.data) },
  });
  const { hasPermission } = usePermissionContext();
  const { mutateAsync, isPending } = useUpdateCompany();
  const { showSuccess, showError } = useNotification();

  const userCanEditCompany = hasPermission({
    permission: 'ADDRESSBOOK_COMPANIES',
    action: 'WRITE',
  });

  const toggleClosePartner = async () => {
    await mutateAsync(
      {
        companyId: id,
        data: { isClosePartner: !company.isClosePartner },
      },
      {
        onSuccess: () => {
          showSuccess({
            title: `${TRANS_KEY}.SUCCESS.TITLE`,
            message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
          });
        },
        onError: (error: AxiosError) => {
          showError({
            title: `${TRANS_KEY}.ERROR.TITLE`,
            message: `${TRANS_KEY}.ERROR.MESSAGE`,
            error,
          });
        },
      }
    );
  };

  return {
    isPartner: company.isClosePartner,
    isPending,
    toggleClosePartner,
    canEdit: userCanEditCompany,
  };
};
